import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { env } from "../env";
import { getLocalStorage } from "../utils/function/localStorage";

export const userApi = createApi({
  reducerPath: "userApi",
  baseQuery: fetchBaseQuery({
    baseUrl: env.BASE_URL,
    // mode: "cors",
    prepareHeaders: (headers) => {
      // console.log(getLocalStorage("safe_secure_token"))
      headers.set("authorization", getLocalStorage("safe_secure_token"));
      return headers;
    },
  }),
  tagTypes: ["User", "adminUser", "Validate", "autoTrade"], // automatic-data fetching
  endpoints: (builder) => ({
    getLoginUser: builder.query({
      query: () => "/api/v1/common/get_user",
      providesTags: ["User"], // automatic-data fetching
    }),
    getAutopoolOneStatus: builder.query({
      query: () => "/api/v1/secure/autopool_one_status",
      providesTags: ["User"], // automatic-data fetching
    }),
    // for auth user
    addUser: builder.mutation({
      // user register
      query: (body) => ({
        url: "/api/v1/public/register",
        method: "POST",
        body,
      }),
      invalidatesTags: ["User"], // automatic-data fetching
    }),
    addLogin: builder.mutation({
      // user login
      query: (body) => ({
        url: "/api/v1/public/login",
        method: "POST",
        body,
      }),
      invalidatesTags: ["User"], // automatic-data fetching
    }),
    addUserVerify: builder.mutation({
      query: (token) => ({
        url: `/api/v1/public/verify_user/${token}`,
        method: "PUT",
      }),
      invalidatesTags: ["User"], // automatic-data fetching
    }),
    addForgotPass: builder.mutation({
      query: (body) => ({
        url: "/api/v1/public/forgot_password",
        method: "POST",
        body,
      }),
      invalidatesTags: ["User"], // automatic-data fetching
    }),
    addOtp: builder.mutation({
      query: (body) => ({
        url: "/api/v1/public/create_otp",
        method: "POST",
        body: body,
      }),
      // invalidatesTags: ["User"], // automatic-data fetching
    }),
    addResetPass: builder.mutation({
      query: ({ token, password }) => ({
        url: `/api/v1/public/reset_password/${token}`,
        method: "POST",
        body: { password: password },
      }),
      invalidatesTags: ["User"], // automatic-data fetching
    }),
    getValidateSponsorName: builder.query({
      query: (user_id) => `/api/v1/public/get_sponsor/${user_id}`,
      providesTags: ["Validate"], // automatic-data fetching
    }),
    getValidateSponsorId: builder.query({
      query: (sponsor_id) => `/api/v1/public/get_sponsor/${sponsor_id}`,
      providesTags: ["Validate"], // automatic-data fetching
    }),
    getValidateEmail: builder.query({
      query: (email) => `/api/v1/public/check_email/${email}`,
      providesTags: ["Validate"], // automatic-data fetching
    }),
    getValidateMobile: builder.query({
      query: (mobile) => `/api/v1/public/check_mobile/${mobile}`,
      providesTags: ["Validate"], // automatic-data fetching
    }),
    getLevelStopCondition: builder.query({
      query: () => `/api/v1/secure/get_level_stop_condition_by_user`,
      providesTags: ["User"], // automatic-data fetching
    }),
    // get all team member list
    levelTeamList: builder.query({
      // query: (user_id) => `/secure/api/level_team/${user_id}`,
      query: (query) =>
        `/api/v1/secure/get_level_team?page=${query?.page}&limit=${query?.limit}&level=${query.level}`,
      providesTags: ["User"], // automatic-data fetching
    }),
    getDirectTeam: builder.query({
      // query: (user_id) => `/secure/api/level_team/${user_id}`,
      query: (query) =>
        `/api/v1/secure/get_direct_team?page=${query?.page}&limit=${query?.limit}`,
      providesTags: ["User"], // automatic-data fetching
    }),
    getRankAchieversTeam: builder.query({
      // query: (user_id) => `/secure/api/level_team/${user_id}`,
      query: (query) =>
        `/api/v1/secure/get_rank_achievers?page=${query?.page}&limit=${query?.limit}&level=${query.level}`,
      providesTags: ["User"], // automatic-data fetching
    }),
    getTeamBusiness: builder.query({
      // query: (user_id) => `/secure/api/level_team/${user_id}`,
      query: () => `/api/v1/secure/get_level_business`,
      providesTags: ["User"], // automatic-data fetching
    }),
    getMonthlyDirectMember: builder.query({
      query: () => `/secure/api/monthly_direct_member`,
      providesTags: ["User"], // automatic-data fetching
    }),
    getDashboardStats: builder.query({
      // SAST API
      query: () => `/api/v1/secure/get_dashboardStats_by_user`,
      providesTags: ["User"], // automatic-data fetching
    }),
    findThisMonthTotalTeamBusiness: builder.query({
      query: ({
        userId,
        limit,
        page,
        startDate,
        endDate,
        searchById,
        csv,
        level,
      }) => ({
        url: `/api/v1/secure/user/find_this_month_total_team_business?userId=${userId}&page=${page}&limit=${limit}&searchById=${searchById}&startDate=${startDate}&endDate=${endDate}&csv=${csv}&level=${level}`,
      }),
      providesTags: ["User"],
    }),
    getMemberUpgradeBusinessHistory: builder.query({
      query: ({
        level,
        userId,
        limit,
        page,
        startDate,
        endDate,
        searchById,
        csv,
      }) =>
        `/api/v1/secure/user/get_upgrade_team_stats_details?level=${level}&userId=${userId}&page=${page}&limit=${limit}&searchById=${searchById}&startDate=${startDate}&endDate=${endDate}&csv=${csv}`,
      providesTags: ["User"],
      }), // automatic-data fetching
    addTeamStatistics: builder.mutation({
      query: (body) => ({
        url: "/api/v1/secure/user/get_team_stats",
        method: "POST",
        body,
      }),
      invalidatesTags: ["User"],
    }),

    // for crud
    editUser: builder.mutation({
      query: (body) => ({
        url: "/api/v1/secure/user/update_user_info",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["User"],
    }),
    editPassword: builder.mutation({
      query: (body) => ({
        url: "/api/v1/secure/user/change_password",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["User"],
    }),
    editEmail: builder.mutation({
      query: (body) => ({
        url: "/api/v1/secure/user/update_email",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["User"],
    }),
    editTrxPassword: builder.mutation({
      query: (body) => ({
        url: "/api/v1/secure/user/change_trx_password",
        method: "POST",
        body,
      }),
      invalidatesTags: ["User"],
    }),
    editTrxAddress: builder.mutation({
      query: (body) => ({
        url: "/api/v1/secure/user/update_trx_address",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["User"],
    }),
    createOtpForChangeTrxAddress: builder.mutation({
      query: () => ({
        url: "/api/v1/secure/user/create_otp_for_trx_address_change_by_user",
        method: "POST",
      }),
      invalidatesTags: ["User"],
    }),
    matchCurrentEmailOtp: builder.mutation({
      query: (body) => ({
        url: "/api/v1/secure/user/match_current_email_otp",
        method: "POST",
        body,
      }),
      invalidatesTags: ["User"],
    }),
    createOtpForNewEmailAddress: builder.mutation({
      query: (body) => ({
        url: "/api/v1/secure/user/create_otp_for_email_change",
        method: "POST",
        body,
      }),
      invalidatesTags: ["User"],
    }),
    getTrxAddressHistoryByUser: builder.query({
      query: (query) =>
        `/api/v1/secure/user/get_trx_address_history_by_user?page=${query?.page}&limit=${query?.limit}`,
      providesTags: ["User"],
    }),
    editImage: builder.mutation({
      query: (body) => ({
        url: "/api/v1/secure/update_profile_pic",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["User"],
    }),
    addPIN: builder.mutation({
      query: (body) => ({
        url: "/api/v1/secure/user/add_pin",
        method: "POST",
        body,
      }),
      invalidatesTags: ["adminUser"],
    }),

    getAllImage: builder.query({
      query: () => "/api/v1/public/get_all_image",
    }),
    getAllVedio: builder.query({
      query: () => "/api/v1/public/get_all_vedio",
    }),
  }),
});

export const {
  useCreateOtpForNewEmailAddressMutation,
  useMatchCurrentEmailOtpMutation,
  useGetTrxAddressHistoryByUserQuery,
  useGetLoginUserQuery, //
  useGetAutopoolOneStatusQuery, //
  useGetValidateSponsorNameQuery, //
  useGetValidateSponsorIdQuery, //
  useGetValidateEmailQuery, //
  useGetValidateMobileQuery, //
  useGetLevelStopConditionQuery,
  useAddUserMutation, //
  useAddLoginMutation, //
  useAddForgotPassMutation, //
  useAddResetPassMutation, //
  useEditUserMutation, //
  useEditPasswordMutation, //
  useEditTrxPasswordMutation, //
  useEditTrxAddressMutation, //
  useCreateOtpForChangeTrxAddressMutation,
  useEditEmailMutation, //
  useAddOtpMutation, //
  useLevelTeamListQuery, //
  useGetDirectTeamQuery, //
  useGetRankAchieversTeamQuery, //
  useEditImageMutation, //
  useGetMonthlyDirectMemberQuery, //
  useGetDashboardStatsQuery, //
  useAddUserVerifyMutation, //
  useGetTeamBusinessQuery, //
  useAddPINMutation, //
  useGetAllImageQuery, //
  useGetAllVedioQuery, //
  useFindThisMonthTotalTeamBusinessQuery,
  useAddTeamStatisticsMutation,
  useGetMemberUpgradeBusinessHistoryQuery
} = userApi;
